module.exports = __webpack_public_path__ + "img/receive@2x.f2ab241c.png";